import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, Table, Button, Container, Modal, Row, Col, Card } from 'react-bootstrap';

const UserForm = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [UserModal, setModal] = useState(false);
    useEffect(() => {
        setLoading(true);
        const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
        axios
            .get(baseUrl + '/api/users')
            .then((response) => {
                console.log(users,'users');
                setUsers(response.data.users);
            })
            .catch((err) => {
                setError('Error fetching data');
            })
            .finally(() => {
                setLoading(false);
            });
    },[]);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        role: ''
    });
    const addUser = () => {
        setModal(true);
    }
    const CloseModal = () => {
        setModal(false);
    };
    const [errors, setErrors] = useState({});
    const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
    const [message, setMessage] = useState("");
    // const [loading, setLoading] = useState(true);
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Invalid email format';
        if (!formData.phone) newErrors.phone = 'Phone is required';
        else if (!/^\d{10}$/.test(formData.phone)) newErrors.phone = 'Invalid phone number (10 digits)';
        if (!formData.password) newErrors.password = 'Password is required';
        else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                const response = await axios.post("http://dawsonhighwaycafeandindiancuisine.com/api/register_user.php", {
                    'name': formData.name,
                    'email': formData.email,
                    'password': formData.password,
                    'phone_number': formData.phone,
                });
                if (response.data.status === 200) {
                    setMessage(response.data.message);
                    setFormData({
                        name: "",
                        email: "",
                        phone_number: "",
                        password: "",
                    });
                } else {
                    setMessage("❌ Something went wrong!");
                }
            } catch (error) {
                setMessage("❌ Error submitting form!");
            } finally {
                setLoading(false);
            }
            console.log('Form submitted:', formData);
            // Add your submission logic here
        } else {
            console.log('error');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    return (
        <Container className="container_wrapper_out page_wrapper">
            <Row className="justify-content-center">
                <Col md={12}>
                    <div class="bg-dark text-white p-2">
                    <h5 class="mt-2" style={{ display: 'inline-block', width: "90%" }}>
                        All Users
                    </h5>
                    <button type="button" class="btn btn-success user_add" onClick={addUser}>Add User</button>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Password</th>
                                {/* <th>Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, index) => (
                                <tr key={user.id || index}>
                                    <td>{index + 1}</td>
                                    <td>{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>{user.phone_number}</td>
                                    <td>{user.plain_password}</td>
                                    {/* <td>
                                    <Button className="btn btn-xs" onClick={() => handleShowModal(artist)}><i class="bi bi-eye"></i></Button>
                                    <Button className="btn btn-xs btn-warning" onClick={() => handleEditModal(artist)}><i class="bi bi-pencil-square"></i></Button>
                                    <Button className="btn btn-xs btn-danger" onClick={() => deleteArtist(artist.id)}> <i class="bi bi-trash3"></i> </Button>
                                </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            {/* Artist Modal */}
            <Modal show={UserModal} onHide={CloseModal}>
                <Modal.Header className='bg-dark text-white' closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {message && <div className="alert alert-success">{message}</div>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.name}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.email}
                            </Form.Control.Feedback>
                        </Form.Group>
                        {/* <Form.Group className="mb-3">
                                    <Form.Label>Role</Form.Label>
                                    <Form.Select
                                        name="role"
                                        value={formData.role}
                                        onChange={handleChange}
                                        isInvalid={!!errors.role}
                                    >
                                        <option value="">Select Role</option>
                                        <option value="artist">Artist</option>
                                        <option value="guest">Guest User</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.role}
                                    </Form.Control.Feedback>
                                </Form.Group> */}


                        <Form.Group className="mb-3">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                isInvalid={!!errors.phone}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.phone}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                isInvalid={!!errors.password}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.password}
                            </Form.Control.Feedback>
                        </Form.Group>


                        <Button variant="danger" type="submit" className="w-100">
                            Register
                        </Button>
                    </Form>
                </Modal.Body>
                <Modal.Footer className='bg-dark text-white'>
                    <Button variant="secondary" onClick={CloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default UserForm;